import { Field } from 'formik'
import React, { PureComponent } from 'react'
import HigherOrderField from './higher-order-field.component'

class BaseInput extends PureComponent {
	constructor(props) {
		super(props)
		const { elementRef } = this.props
		this.elementRef = elementRef || React.createRef()
	}

	render() {
		const {
			id,
			type,
			icon,
			value,
			style,
			onBlur,
			disabled,
			onChange,
			position,
			attribute,
			minLength,
			maxLength,
			placeholder
		} = this.props

		return (
			<HigherOrderField innerRef={this.elementRef} {...this.props}>
				<Field
					autoCorrect="nope"
					autoComplete="off"
					innerRef={this.elementRef}
					type={type}
					id={id}
					name={id}
					data-attribute={attribute + '-' + position}
					className={icon ? 'with-icon' : ''}
					minLength={minLength}
					maxLength={maxLength}
					placeholder={placeholder}
					disabled={disabled}
					value={value || ''}
					onChange={onChange}
					onBlur={onBlur}
					style={style}
				/>
			</HigherOrderField>
		)
	}
}

export default BaseInput
